<template>
  <EditableWrapper typePanel="actionContacts" :disabled="!isEditHeader">
    <div
      :class="style.actionBlock"
      v-if="actions"
      :style="{marginBottom: isEditHeader ? '0' : ''}"
    >
      <h1
        v-if="
          displayActionHeaderContacts && actions.length > 0 && !isEditHeader
        "
        v-text="displayActionHeaderContacts"
      />

      <input
        v-else-if="isEditHeader"
        :value="actionHeaderContacts"
        ref="headerInput"
        :size="actionHeaderContacts?.length ?? 10"
        :style="{
          width: inputWidth * 10 + 'px'
        }"
        placeholder="Заголовок акций"
        @input="updateActionHeaderContacts"
      />

      <!-- Список акций -->
      <div :class="style.actionList">
        <div
          :class="style.action"
          v-for="action in actions"
          :key="action.header"
          ref="action"
        >
          <span :class="style.checkMarkIcon">
            <img src="$images/check.svg" alt="" />
          </span>
          <div
            :class="style.actionWrapper"
            v-if="action?.header"
            v-text="action.header"
          />
        </div>
      </div>
    </div>
  </EditableWrapper>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./ActionGradientComponent.module.scss";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import {action, Quiz} from "@/page/quiz/typeQuiz";
import EditableWrapper from "@/page/quiz/editor/landingPage/components/elements/EditableWrapper/EditableWrapper.vue";

export default defineComponent({
  name: "ActionGradientComponent",
  components: {EditableWrapper},
  props: {
    isEditHeader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style,
      modifyQuiz
    };
  },
  mounted() {
    if (this.modifyQuiz("get", "", ["actionList"]) && !this.isEditHeader) {
      const actionList = this.$refs.action as HTMLDivElement[];
      actionList.forEach((item) => {
        item.style.opacity = "0";
        item.style.transform = "translateX(100%)";
      });

      setTimeout(() => {
        const actionList = this.$refs.action as HTMLDivElement[];
        actionList.forEach((item, index) => {
          setTimeout(() => {
            item.style.opacity = "1";
            item.style.transform = "translateX(0%)";
          }, 100 * index);
        });
      }, 300);
    }
  },
  methods: {
    updateActionHeaderContacts(event: Event): void {
      const target = event.target as HTMLInputElement;

      if (this.contactsQuestionIndex === -1) {
        return;
      }

      this.modifyQuiz("set", target.value, [
        "questions",
        this.contactsQuestionIndex,
        "contacts",
        "headerActionMobile",
        "placeholder"
      ]);
    }
  },
  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },
    mobileVersion() {
      return this.$quizStore.getMobileVersion;
    },
    actions(): action[] {
      const actions = this.modifyQuiz("get", "", ["actionList"]);

      return Array.isArray(actions) ? actions : [];
    },
    contactsQuestionIndex(): number {
      const contactsQuestionIndex = this.quiz.questions.findIndex(
        (question) => {
          return question?.type === "contacts";
        }
      );

      if (contactsQuestionIndex !== -1) {
        return contactsQuestionIndex;
      }

      if (this.quiz.questions.length >= 2) {
        return this.quiz.questions.length - 2;
      }

      return -1;
    },
    contactsQuestion() {
      if (this.contactsQuestionIndex === -1) {
        return null;
      }

      return this.quiz.questions[this.contactsQuestionIndex]?.contacts ?? null;
    },
    actionHeaderContacts(): string {
      if (this.isEditHeader) {
        return (
          this.modifyQuiz("get", "", [
            "questions",
            this.contactsQuestionIndex,
            "contacts",
            "headerActionMobile",
            "placeholder"
          ]) ?? ""
        );
      }
      if (this.ABTestOn) {
        const ABTestObj = this.quiz.ABTestObj;
        return (
          ABTestObj.questions?.[this.contactsQuestionIndex]?.contacts
            ?.headerActionMobile?.placeholder ?? ""
        );
      }
      return (
        this.quiz?.questions[this.contactsQuestionIndex]?.contacts
          ?.headerActionMobile?.placeholder ?? ""
      );
    },
    displayActionHeaderContacts(): string {
      return this.actionHeaderContacts;
    },
    // ширина инпута в символах
    inputWidth(): number {
      return this.actionHeaderContacts?.length > 0
        ? this.actionHeaderContacts?.length + 1
        : 5;
    },
    ABTestOn(): boolean {
      // const abtest = Boolean(localStorage.getItem('ABTest'))
      return Boolean(localStorage.getItem("ABTest"));
    }
  }
});
</script>
